import styled from "@emotion/styled";
import { Text } from "@otrium/atoms";
import BaseButton from "src/atoms/Button/BaseButton";
import { CloseButton } from "src/atoms/CloseButton";

export const FacetsContainer = styled.div`
  position: sticky;
  top: 64px;
  display: grid;
  grid-template-columns: auto auto;
  grid-auto-rows: min-content;
  gap: ${({ theme }) => theme.space?.space16};
  padding-block: ${({ theme }) => theme.space?.space8};
  background-color: ${({ theme }) => theme.colors?.tone.white};
  z-index: 1000;

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    padding-block: ${({ theme }) => theme.space.space16};
    top: 58px;
  }
`;

export const ActiveFiltersContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: min-content;
  grid-column: span 3;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space?.space8};
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: none;
  }
`;

export const StatsWrapper = styled.div`
  display: flex;
  min-height: ${({ theme }) => theme.space?.space32};
  place-items: flex-start;
  gap: ${({ theme }) => theme.space?.space4};
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    grid-column: span 2;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints?.md}) {
    margin-left: auto;
  }
`;

export const StyledText = styled(Text)`
  font-size: ${({ theme }) => theme.fontSizes?.fontSize14};
  font-weight: 600;
  margin-right: ${({ theme }) => theme.space?.space4};
  line-height: 1.71;
  color: ${({ theme }) => theme.colors?.tone.anthraciteDark};
`;

export const StyledCloseButton = styled(CloseButton)`
  margin-right: ${({ theme }) => theme.space?.space8};
  padding: 0;
  width: 14px;
  path {
    stroke: ${({ theme }) => theme.colors?.tone.anthraciteLight};
    stroke-width: 2;
  }
  &:hover {
    path {
      stroke: ${({ theme }) => theme.colors?.tone.anthraciteDark};
    }
  }
`;

export const ColorBox = styled.div<{ hex?: string; icon?: string; id: string }>`
  width: 14px;
  height: 14px;
  border-radius: 2px;
  margin-inline: ${({ theme }) => theme.space?.space4};
  ${({ id, theme }) =>
    id === "WHITE" &&
    `
    border: 1px solid;
    border-color: ${theme.colors?.tone.anthraciteLight};
  `}
  ${({ hex, icon }) =>
    !hex &&
    icon &&
    `
    background-position: center;
    background-size: 30px;
    background-image: url(${icon});
  `}
  ${({ hex }) => hex && `background-color: ${hex};`}
`;

export const Button = styled(BaseButton)`
  cursor: pointer;
  border: none;
  background-color: transparent;
  padding-left: 1px;
  font-size: ${({ theme }) => theme.fontSizes?.fontSize14};
  line-height: 1.43;
  color: ${({ theme }) => theme.colors?.tone.anthraciteLight};
  &:hover {
    color: ${({ theme }) => theme.colors?.tone.anthraciteDark};
  }
`;

export const FilterButton = styled.button`
  display: none;
  background-color: transparent;
  border: none;

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: flex;
  }
`;

export const SortStatsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space?.space4};
`;

export const StatsContainer = styled.div`
  display: block;
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: none;
  }
`;
